// Generated by AvenyModelEditor

import { IClientSubSystemModel } from '../../Types/ClientModelTypes';
import { TEDSelectionOperator as T} from '../../globalQueryTypes';

const PU: IClientSubSystemModel = {
  Code: 'PU',
  DisplayLabel: 'Eniac program/Underhåll',
  BusinessModels: {
    PUProgramAndringBild: {
      CollectionName: 'PUProgramAndringBild',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ProgramAndringBild',
        Abstract: false,
        SOLabel: 'Bild',
        SOGLabel: 'Bild',
        SBLabel: 'Bilden',
        SBGLabel: 'Bilden',
        POLabel: 'Bilder',
        POGLabel: 'Bilder',
        PBLabel: 'Bilderna',
        PBGLabel: 'Bilderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bilden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bilden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bilden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bilden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PROG_ANDR_ID: {
          AttributeName: 'PROG_ANDR_ID',
          DisplayLabel: 'Programändrings ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Intern bild/Extern bild',
          DataType: 'Enum',
          EnumValues: new Map([['INTERN_BILD', 'Intern bild'], ['EXTERN_BILD', 'Extern bild']]),
          EnumSortValues: new Map([['INTERN_BILD', 'I'], ['EXTERN_BILD', 'E']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INTERN_BILD=Intern bild;EXTERN_BILD=Extern bild"',
          GUIEditable: true,
        },
        BILD: {
          AttributeName: 'BILD',
          DisplayLabel: 'Bild',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BILDSIZE: {
          AttributeName: 'BILDSIZE',
          DisplayLabel: 'Bildstorlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
        },
      },
      Associations: {
        ProgramAndring: {
          AssociationName: 'ProgramAndring',
          DisplayLabel: 'Program ändring',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'PUProgramAndring',
          AssociatedComponentName: 'ProgramAndring',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    PUUppdateringssteg: {
      CollectionName: 'PUUppdateringssteg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Uppdateringssteg',
        Abstract: false,
        SOLabel: 'Checklista, steg',
        SOGLabel: 'Checklista, steg',
        SBLabel: 'Checklista, steg',
        SBGLabel: 'Checklista, steg',
        POLabel: 'Checklista, steg',
        POGLabel: 'Checklista, steg',
        PBLabel: 'Checklista, steg',
        PBGLabel: 'Checklista, steg',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Checklista, steg primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Checklista, steg versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Checklista, steg id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Checklista, steg fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGSNR: {
          AttributeName: 'ORDNINGSNR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        UPPDATERING_ID: {
          AttributeName: 'UPPDATERING_ID',
          DisplayLabel: 'UPPDATERING_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Klar: {
          AttributeName: 'Klar',
          DisplayLabel: 'Klar',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SENAST_KLART: {
          AttributeName: 'SENAST_KLART',
          DisplayLabel: 'Senast klart',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Ansvariga: {
          AttributeName: 'Ansvariga',
          DisplayLabel: 'Ansvariga',
          Hint: 'Ansvariga för detta steg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
      },
      Associations: {
        uppdatering: {
          AssociationName: 'uppdatering',
          DisplayLabel: 'Uppdatering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'PUUppdatering',
          AssociatedComponentName: 'Uppdatering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        uppdateringansvar: {
          AssociationName: 'uppdateringansvar',
          DisplayLabel: 'Ansvarig för uppdateringssteg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'PUUppdateringAnsvar',
          AssociatedComponentName: 'UppdateringAnsvar',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    PUUppdatering: {
      CollectionName: 'PUUppdatering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Uppdatering',
        Abstract: false,
        SOLabel: 'Checklista',
        SOGLabel: 'Checklista',
        SBLabel: 'Checklista',
        SBGLabel: 'Checklista',
        POLabel: 'Checklista',
        POGLabel: 'Checklista',
        PBLabel: 'Checklista',
        PBGLabel: 'Checklista',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Checklista primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Checklista versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Checklista id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VERSION_MAJOR: {
          AttributeName: 'VERSION_MAJOR',
          DisplayLabel: 'Version, major',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VERSION_MINOR: {
          AttributeName: 'VERSION_MINOR',
          DisplayLabel: 'Version, minor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VERSION_RELEASE: {
          AttributeName: 'VERSION_RELEASE',
          DisplayLabel: 'Version, release',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MALL: {
          AttributeName: 'MALL',
          DisplayLabel: 'Mall',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        version: {
          AttributeName: 'version',
          DisplayLabel: 'Version',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        MALL_ID: {
          AttributeName: 'MALL_ID',
          DisplayLabel: 'MALL_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        PLANERAD_KLAR: {
          AttributeName: 'PLANERAD_KLAR',
          DisplayLabel: 'Planerat klar-datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        klar: {
          AttributeName: 'klar',
          DisplayLabel: 'Klar',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        versionsortorder: {
          AttributeName: 'versionsortorder',
          DisplayLabel: 'versionsortorder',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True; ConditionShowValuesFilter={ANV_FOR} = \'R\' and ISNULL({BORTTAGEN}, \'N\') = \'N\' and ISNULL({MALL}, \'N\') = \'N\'']]),
        },
        ANV_FOR: {
          AttributeName: 'ANV_FOR',
          DisplayLabel: 'Används för',
          Hint: 'Release/Utvecklingskalender',
          DataType: 'Enum',
          EnumValues: new Map([['RELEASE', 'Release'], ['UTVECKLINGSKALENDER', 'Utvecklingskalender']]),
          EnumSortValues: new Map([['RELEASE', 'R'], ['UTVECKLINGSKALENDER', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="RELEASE=Release;UTVECKLINGSKALENDER=Utvecklingskalender"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
      },
      Associations: {
        mall: {
          AssociationName: 'mall',
          DisplayLabel: 'Mall',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'PUUppdatering',
          AssociatedComponentName: 'Uppdatering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        uppdateringssteg: {
          AssociationName: 'uppdateringssteg',
          DisplayLabel: 'Steg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'PUUppdateringssteg',
          AssociatedComponentName: 'Uppdateringssteg',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    PUDatabaslogg: {
      CollectionName: 'PUDatabaslogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'DatabasLogg',
        Abstract: false,
        SOLabel: 'Databaslogg',
        SOGLabel: 'Databaslogg',
        SBLabel: 'Databasloggen',
        SBGLabel: 'Databasloggen',
        POLabel: 'Databasloggar',
        POGLabel: 'Databasloggar',
        PBLabel: 'Databasloggarna',
        PBGLabel: 'Databasloggarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Databasloggen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Databasloggen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Databasloggen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Databasloggen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VERSION_MAJOR: {
          AttributeName: 'VERSION_MAJOR',
          DisplayLabel: 'Version major',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10000"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        VERSION_MINOR: {
          AttributeName: 'VERSION_MINOR',
          DisplayLabel: 'Version minor',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10000"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        VERSION_RELEASE: {
          AttributeName: 'VERSION_RELEASE',
          DisplayLabel: 'Version release',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10000"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        VERSION_BUILD: {
          AttributeName: 'VERSION_BUILD',
          DisplayLabel: 'Version build',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10000"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
        },
        FORANDRADE_TABELLER: {
          AttributeName: 'FORANDRADE_TABELLER',
          DisplayLabel: 'Förändrade tabeller',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FORANDRING: {
          AttributeName: 'FORANDRING',
          DisplayLabel: 'Förändring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KONTROLL_QUERY: {
          AttributeName: 'KONTROLL_QUERY',
          DisplayLabel: 'Kontroll Query',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        NO_TRANSACTION: {
          AttributeName: 'NO_TRANSACTION',
          DisplayLabel: 'Kör utan transaktion',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        Version: {
          AttributeName: 'Version',
          DisplayLabel: 'Version',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
      },
      Associations: {
        Rader: {
          AssociationName: 'Rader',
          DisplayLabel: 'Rader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'PUDatabasloggRad',
          AssociatedComponentName: 'DatabasloggRad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    PUProgramAndringDel: {
      CollectionName: 'PUProgramAndringDel',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ProgramAndringDel',
        Abstract: false,
        SOLabel: 'Deluppgift',
        SOGLabel: 'Deluppgift',
        SBLabel: 'Deluppgiften',
        SBGLabel: 'Deluppgiften',
        POLabel: 'Deluppgifter',
        POGLabel: 'Deluppgifter',
        PBLabel: 'Deluppgifterna',
        PBGLabel: 'Deluppgifterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Deluppgiften primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Deluppgiften versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Deluppgiften id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Deluppgiften fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDN_NR: {
          AttributeName: 'ORDN_NR',
          DisplayLabel: 'Ordningsnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PROG_ANDR_ID: {
          AttributeName: 'PROG_ANDR_ID',
          DisplayLabel: 'Programändrings ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KLAR: {
          AttributeName: 'KLAR',
          DisplayLabel: 'Klar',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'PUProgramAndringDelBlob',
          AssociatedComponentName: 'ProgramAndringDelBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
      },
    },
    PUProgramAndringDelBlob: {
      CollectionName: 'PUProgramAndringDelBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ProgramAndringDelBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'PUProgramAndringDelBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'PUProgramAndringDelBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'PUProgramAndringDelBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'PUProgramAndringDelBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
      },
      Associations: {
      },
    },
    PUProgAndrOLE: {
      CollectionName: 'PUProgAndrOLE',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ProgAndrOLE',
        Abstract: false,
        SOLabel: 'Dokument',
        SOGLabel: 'Dokument',
        SBLabel: 'Dokumentet',
        SBGLabel: 'Dokumentet',
        POLabel: 'Dokument',
        POGLabel: 'Dokument',
        PBLabel: 'Dokumenten',
        PBGLabel: 'Dokumenten',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokumentet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokumentet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dokumentet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokumentet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filtillägg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        OLECLASSNAME: {
          AttributeName: 'OLECLASSNAME',
          DisplayLabel: 'OLE klassnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BINARDATA: {
          AttributeName: 'BINARDATA',
          DisplayLabel: 'Dokument',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BINARDATASIZE: {
          AttributeName: 'BINARDATASIZE',
          DisplayLabel: 'BlobStorlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ApplicationIdentifier: {
          AttributeName: 'ApplicationIdentifier',
          DisplayLabel: 'Applikation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        FileIdentifier: {
          AttributeName: 'FileIdentifier',
          DisplayLabel: 'Filidentifikation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatype',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        FILNAMN: {
          AttributeName: 'FILNAMN',
          DisplayLabel: 'Filnamn (länk)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
      },
    },
    PUFAQ: {
      CollectionName: 'PUFAQ',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'FAQ',
        Abstract: false,
        SOLabel: 'FAQ',
        SOGLabel: 'FAQ',
        SBLabel: 'FAQ',
        SBGLabel: 'FAQ',
        POLabel: 'FAQ',
        POGLabel: 'FAQ',
        PBLabel: 'FAQ',
        PBGLabel: 'FAQ',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'FAQ primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'FAQ versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'FAQ id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'FAQ fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUBSYSTEM: {
          AttributeName: 'SUBSYSTEM',
          DisplayLabel: 'Delsystem',
          Hint: 'Grundsystem/Avenycentralen/Anläggningsredovisning/Bisättning/Bokning/Diarium/Ekonomi/Grav/Kremation/Kundreskontra/Lager/Leverantörsreskontra/Musik/Order/Fakturering/Organisation/Person/Program/Underhåll/WebBisättning/WebBokning/WebEkonomi',
          DataType: 'Enum',
          EnumValues: new Map([['GRUNDSYSTEM', 'Grundsystem'], ['AVENYCENTRALEN', 'Avenycentralen'], ['ANLAGGNINGSREDOVISNING', 'Anläggningsredovisning'], ['BISATTNING', 'Bisättning'], ['BOKNING', 'Bokning'], ['DIARIUM', 'Diarium'], ['EKONOMI', 'Ekonomi'], ['GRAV', 'Grav'], ['KREMATION', 'Kremation'], ['KUNDRESKONTRA', 'Kundreskontra'], ['LAGER', 'Lager'], ['LEVERANTORSRESKONTRA', 'Leverantörsreskontra'], ['MUSIK', 'Musik'], ['ORDER_FAKTURERING', 'Order/Fakturering'], ['ORGANISATION_PERSON', 'Organisation/Person'], ['PROGRAM_UNDERHALL', 'Program/Underhåll'], ['WEBBISATTNING', 'WebBisättning'], ['WEBBOKNING', 'WebBokning'], ['WEBEKONOMI', 'WebEkonomi']]),
          EnumSortValues: new Map([['GRUNDSYSTEM', 'GND'], ['AVENYCENTRALEN', 'ACC'], ['ANLAGGNINGSREDOVISNING', 'AR'], ['BISATTNING', 'BJ'], ['BOKNING', 'BO'], ['DIARIUM', 'DI'], ['EKONOMI', 'EK'], ['GRAV', 'GA'], ['KREMATION', 'KJ'], ['KUNDRESKONTRA', 'KR'], ['LAGER', 'LA'], ['LEVERANTORSRESKONTRA', 'LR'], ['MUSIK', 'MU'], ['ORDER_FAKTURERING', 'OF'], ['ORGANISATION_PERSON', 'OP'], ['PROGRAM_UNDERHALL', 'PU'], ['WEBBISATTNING', 'WBJ'], ['WEBBOKNING', 'WBO'], ['WEBEKONOMI', 'WEK']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GRUNDSYSTEM=Grundsystem;AVENYCENTRALEN=Avenycentralen;ANLAGGNINGSREDOVISNING=Anläggningsredovisning;BISATTNING=Bisättning;BOKNING=Bokning;DIARIUM=Diarium;EKONOMI=Ekonomi;GRAV=Grav;KREMATION=Kremation;KUNDRESKONTRA=Kundreskontra;LAGER=Lager;LEVERANTORSRESKONTRA=Leverantörsreskontra;MUSIK=Musik;ORDER_FAKTURERING=Order/Fakturering;ORGANISATION_PERSON=Organisation/Person;PROGRAM_UNDERHALL=Program/Underhåll;WEBBISATTNING=WebBisättning;WEBBOKNING=WebBokning;WEBEKONOMI=WebEkonomi"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        RUTIN_ID: {
          AttributeName: 'RUTIN_ID',
          DisplayLabel: 'RutinID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INTERN: {
          AttributeName: 'INTERN',
          DisplayLabel: 'Intern',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        FRAGA: {
          AttributeName: 'FRAGA',
          DisplayLabel: 'Fråga',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SVAR: {
          AttributeName: 'SVAR',
          DisplayLabel: 'Svar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SKAPAD_AV: {
          AttributeName: 'SKAPAD_AV',
          DisplayLabel: 'Skapad av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKAPAD_DATUM: {
          AttributeName: 'SKAPAD_DATUM',
          DisplayLabel: 'Skapad datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        ANDRAD_AV: {
          AttributeName: 'ANDRAD_AV',
          DisplayLabel: 'Ändrad av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANDRAD_DATUM: {
          AttributeName: 'ANDRAD_DATUM',
          DisplayLabel: 'Ändrad datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        RutinNamn: {
          AttributeName: 'RutinNamn',
          DisplayLabel: 'Rutinnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DelprogRutinFraga: {
          AttributeName: 'DelprogRutinFraga',
          DisplayLabel: 'DelprogRutinFraga',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
      },
    },
    PUFinnsFranVer: {
      CollectionName: 'PUFinnsFranVer',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'FinnsFranVersion',
        Abstract: false,
        SOLabel: 'Finns från version',
        SOGLabel: 'Finns från version',
        SBLabel: 'Finns från version',
        SBGLabel: 'Finns från version',
        POLabel: 'Finns från version',
        POGLabel: 'Finns från version',
        PBLabel: 'Finns från version',
        PBGLabel: 'Finns från version',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Finns från version primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Finns från version versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Finns från version id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Finns från version fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUBSYSTEMCODE: {
          AttributeName: 'SUBSYSTEMCODE',
          DisplayLabel: 'Delsystem',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        VERSION_MAJOR: {
          AttributeName: 'VERSION_MAJOR',
          DisplayLabel: 'Version major',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        VERSION_MINOR: {
          AttributeName: 'VERSION_MINOR',
          DisplayLabel: 'Version minor',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        VERSION_RELEASE: {
          AttributeName: 'VERSION_RELEASE',
          DisplayLabel: 'Version release',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        VERSION_BUILD: {
          AttributeName: 'VERSION_BUILD',
          DisplayLabel: 'Version build',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        PROGRAM_NAMN: {
          AttributeName: 'PROGRAM_NAMN',
          DisplayLabel: 'Programnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUBSYSTEMNAME: {
          AttributeName: 'SUBSYSTEMNAME',
          DisplayLabel: 'Delsystemnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Version: {
          AttributeName: 'Version',
          DisplayLabel: 'Version',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
      },
      Associations: {
        ProgAndr: {
          AssociationName: 'ProgAndr',
          DisplayLabel: 'Uppgift',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'PUProgramAndring',
          AssociatedComponentName: 'ProgramAndring',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    PUFinnsPaLogg: {
      CollectionName: 'PUFinnsPaLogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'FinnsPaLogg',
        Abstract: false,
        SOLabel: 'Finns på ändringslogg',
        SOGLabel: 'Finns på ändringslogg',
        SBLabel: 'Finns på ändringslogg',
        SBGLabel: 'Finns på ändringslogg',
        POLabel: 'Finns på ändringslogg',
        POGLabel: 'Finns på ändringslogg',
        PBLabel: 'Finns på ändringslogg',
        PBGLabel: 'Finns på ändringslogg',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Finns på ändringslogg primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Finns på ändringslogg versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Finns på ändringslogg id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Finns på ändringslogg fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Titel: {
          AttributeName: 'Titel',
          DisplayLabel: 'Titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Uppgiftsnr: {
          AttributeName: 'Uppgiftsnr',
          DisplayLabel: 'Uppgiftsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Intern: {
          AttributeName: 'Intern',
          DisplayLabel: 'Intern',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AndringsLoggSkapadDatum: {
          AttributeName: 'AndringsLoggSkapadDatum',
          DisplayLabel: 'Datum',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AndringsLoggSkapadAv: {
          AttributeName: 'AndringsLoggSkapadAv',
          DisplayLabel: 'Skapad av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AndringsLoggFromDatum: {
          AttributeName: 'AndringsLoggFromDatum',
          DisplayLabel: 'Fr.o.m datum',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AndringsLoggTomDatum: {
          AttributeName: 'AndringsLoggTomDatum',
          DisplayLabel: 'T.o.m datum',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AndringsLoggFromVersion: {
          AttributeName: 'AndringsLoggFromVersion',
          DisplayLabel: 'Fr.o.m version',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AndringsLoggTomVersion: {
          AttributeName: 'AndringsLoggTomVersion',
          DisplayLabel: 'T.o.m version',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        ProgramAndring: {
          AssociationName: 'ProgramAndring',
          DisplayLabel: 'Programändring',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'PUProgramAndring',
          AssociatedComponentName: 'ProgramAndring',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        AndringsLogg: {
          AssociationName: 'AndringsLogg',
          DisplayLabel: 'Ändringslogg',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'PUAndringsLogg',
          AssociatedComponentName: 'AndringsLogg',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    PUProgramAndring: {
      CollectionName: 'PUProgramAndring',
      UDAEnabled: true,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '12002']]),
      RootType: {
        TypeValue: 'ProgramAndring',
        Abstract: false,
        SOLabel: 'Program ändring',
        SOGLabel: 'Program ändring',
        SBLabel: 'Program ändringen',
        SBGLabel: 'Program ändringen',
        POLabel: 'Program ändringar',
        POGLabel: 'Program ändringar',
        PBLabel: 'Program ändringarna',
        PBGLabel: 'Program ändringarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Program ändringen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Program ändringen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Program ändringen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Program ändringen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Aveny/Meny-Spar/Konverteringar/Installationer',
          DataType: 'Enum',
          EnumValues: new Map([['AVENY', 'Aveny'], ['MENY_SPAR', 'Meny-Spar'], ['KONVERTERINGAR', 'Konverteringar'], ['INSTALLATIONER', 'Installationer']]),
          EnumSortValues: new Map([['AVENY', 'A'], ['MENY_SPAR', 'M'], ['KONVERTERINGAR', 'K'], ['INSTALLATIONER', 'I']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AVENY=Aveny;MENY_SPAR=Meny-Spar;KONVERTERINGAR=Konverteringar;INSTALLATIONER=Installationer"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        KATEGORI: {
          AttributeName: 'KATEGORI',
          DisplayLabel: 'Kategori',
          Hint: 'Dokumentation/Drift/Felrättning/Försäljning/Konvertering/Leverans/Programändring/Programtillägg/Utbildning/Övrigt/Malluppgift',
          DataType: 'Enum',
          EnumValues: new Map([['DOKUMENTATION', 'Dokumentation'], ['DRIFT', 'Drift'], ['FELRATTNING', 'Felrättning'], ['FORSALJNING', 'Försäljning'], ['KONVERTERING', 'Konvertering'], ['LEVERANS', 'Leverans'], ['PROGRAMANDRING', 'Programändring'], ['PROGRAMTILLAGG', 'Programtillägg'], ['UTBILDNING', 'Utbildning'], ['OVRIGT', 'Övrigt'], ['MALLUPPGIFT', 'Malluppgift']]),
          EnumSortValues: new Map([['DOKUMENTATION', 'D'], ['DRIFT', 'R'], ['FELRATTNING', 'F'], ['FORSALJNING', 'S'], ['KONVERTERING', 'K'], ['LEVERANS', 'L'], ['PROGRAMANDRING', 'Ä'], ['PROGRAMTILLAGG', 'T'], ['UTBILDNING', 'U'], ['OVRIGT', 'Ö'], ['MALLUPPGIFT', 'M']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="DOKUMENTATION=Dokumentation;DRIFT=Drift;FELRATTNING=Felrättning;FORSALJNING=Försäljning;KONVERTERING=Konvertering;LEVERANS=Leverans;PROGRAMANDRING=Programändring;PROGRAMTILLAGG=Programtillägg;UTBILDNING=Utbildning;OVRIGT=Övrigt;MALLUPPGIFT=Malluppgift"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        TITEL: {
          AttributeName: 'TITEL',
          DisplayLabel: 'Titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        TITEL_EXT: {
          AttributeName: 'TITEL_EXT',
          DisplayLabel: 'Extern titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SENAST_DATUM: {
          AttributeName: 'SENAST_DATUM',
          DisplayLabel: 'Prog senast datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Felrapporterad/Förslag/Granskad/Beslutad av delprog.ansv/Skall specas/Specning pågår/Utdelad för programmering/Mottagen av programmerare/Påbörjad programmering/Klar för programtest/Skall godkännas/Godkänd, hanteras i aktuell version/Publicerad i aktuell version/Dokumenteras, i övrigt klar/Godkänn dokumentation, i övrigt klar/Klar/Refuserad',
          DataType: 'Enum',
          EnumValues: new Map([['FELRAPPORTERAD', 'Felrapporterad'], ['FORSLAG', 'Förslag'], ['GRANSKAD', 'Granskad'], ['BESLUTAD_AV_DELPROG_ANSV', 'Beslutad av delprog.ansv'], ['SKALL_SPECAS', 'Skall specas'], ['SPECNING_PAGAR', 'Specning pågår'], ['UTDELAD_FOR_PROGRAMMERING', 'Utdelad för programmering'], ['MOTTAGEN_AV_PROGRAMMERARE', 'Mottagen av programmerare'], ['PABORJAD_PROGRAMMERING', 'Påbörjad programmering'], ['KLAR_FOR_PROGRAMTEST', 'Klar för programtest'], ['SKALL_GODKANNAS', 'Skall godkännas'], ['GODKAND__HANTERAS_I_AKTUELL_VERSION', 'Godkänd, hanteras i aktuell version'], ['PUBLICERAD_I_AKTUELL_VERSION', 'Publicerad i aktuell version'], ['DOKUMENTERAS__I_OVRIGT_KLAR', 'Dokumenteras, i övrigt klar'], ['GODKANN_DOKUMENTATION__I_OVRIGT_KLAR', 'Godkänn dokumentation, i övrigt klar'], ['KLAR', 'Klar'], ['REFUSERAD', 'Refuserad']]),
          EnumSortValues: new Map([['FELRAPPORTERAD', '4'], ['FORSLAG', 'F'], ['GRANSKAD', 'E'], ['BESLUTAD_AV_DELPROG_ANSV', '5'], ['SKALL_SPECAS', 'S'], ['SPECNING_PAGAR', 'P'], ['UTDELAD_FOR_PROGRAMMERING', 'C'], ['MOTTAGEN_AV_PROGRAMMERARE', 'D'], ['PABORJAD_PROGRAMMERING', 'B'], ['KLAR_FOR_PROGRAMTEST', 'A'], ['SKALL_GODKANNAS', '6'], ['GODKAND__HANTERAS_I_AKTUELL_VERSION', 'H'], ['PUBLICERAD_I_AKTUELL_VERSION', 'V'], ['DOKUMENTERAS__I_OVRIGT_KLAR', '7'], ['GODKANN_DOKUMENTATION__I_OVRIGT_KLAR', '8'], ['KLAR', 'K'], ['REFUSERAD', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FELRAPPORTERAD=Felrapporterad;FORSLAG=Förslag;GRANSKAD=Granskad;BESLUTAD_AV_DELPROG_ANSV=Beslutad av delprog.ansv;SKALL_SPECAS=Skall specas;SPECNING_PAGAR=Specning pågår;UTDELAD_FOR_PROGRAMMERING=Utdelad för programmering;MOTTAGEN_AV_PROGRAMMERARE=Mottagen av programmerare;PABORJAD_PROGRAMMERING=Påbörjad programmering;KLAR_FOR_PROGRAMTEST=Klar för programtest;SKALL_GODKANNAS=Skall godkännas;GODKAND__HANTERAS_I_AKTUELL_VERSION=Godkänd, hanteras i aktuell version;PUBLICERAD_I_AKTUELL_VERSION=Publicerad i aktuell version;DOKUMENTERAS__I_OVRIGT_KLAR=Dokumenteras, i övrigt klar;GODKANN_DOKUMENTATION__I_OVRIGT_KLAR=Godkänn dokumentation, i övrigt klar;KLAR=Klar;REFUSERAD=Refuserad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        STATUS_DATUM: {
          AttributeName: 'STATUS_DATUM',
          DisplayLabel: 'Status datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        STATUS_TID: {
          AttributeName: 'STATUS_TID',
          DisplayLabel: 'Status tid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
        },
        TID_UPPSK: {
          AttributeName: 'TID_UPPSK',
          DisplayLabel: 'Tid uppskattad, prog',
          Hint: 'Uppskattad tid för programmering/test',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="v=40;d=8;h=1";DefaultGroup="h";GroupTexts="v=v;vecka=v;veckor=v;d=d;dag=d;dagar=d;t=t;tim=t;timmar=t"',
          FormatterDisplayParams: 'Groups="v=40;d=8;h=1"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TID_KVAR: {
          AttributeName: 'TID_KVAR',
          DisplayLabel: 'Tid kvar, prog',
          Hint: 'Tid kvar för programmering/test',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="v=40;d=8;h=1";DefaultGroup="h";GroupTexts="v=v;vecka=v;veckor=v;d=d;dag=d;dagar=d;t=t;tim=t;timmar=t"',
          FormatterDisplayParams: 'Groups="v=40;d=8;h=1"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TID_KVAR_ANDRAD_DATUM: {
          AttributeName: 'TID_KVAR_ANDRAD_DATUM',
          DisplayLabel: 'Datum för senaste ändring i tid kvar',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        TID_KVAR_ANDRAD_TID: {
          AttributeName: 'TID_KVAR_ANDRAD_TID',
          DisplayLabel: 'Tidpunkt för senaste ändring i tid kvar',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
        },
        REGISTRERAT_AV: {
          AttributeName: 'REGISTRERAT_AV',
          DisplayLabel: 'Registrerat av',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORSLAGSSTALLARE: {
          AttributeName: 'FORSLAGSSTALLARE',
          DisplayLabel: 'Förslagsställare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ANSVARIG: {
          AttributeName: 'ANSVARIG',
          DisplayLabel: 'Programmeras av',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PRIORITET: {
          AttributeName: 'PRIORITET',
          DisplayLabel: 'Prioritet',
          Hint: '1/2/3/4/5/6/7/8/9/10',
          DataType: 'Enum',
          EnumValues: new Map([['P1', '1'], ['P2', '2'], ['P3', '3'], ['P4', '4'], ['P5', '5'], ['P6', '6'], ['P7', '7'], ['P8', '8'], ['P9', '9'], ['P10', '10']]),
          EnumSortValues: new Map([['P1', '1'], ['P2', '2'], ['P3', '3'], ['P4', '4'], ['P5', '5'], ['P6', '6'], ['P7', '7'], ['P8', '8'], ['P9', '9'], ['P10', '10']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="P1=1;P2=2;P3=3;P4=4;P5=5;P6=6;P7=7;P8=8;P9=9;P10=10"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notgreater,
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordnings nummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="1000000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        INTERN: {
          AttributeName: 'INTERN',
          DisplayLabel: 'Intern',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        PUBL_FRAN_VERSION_MAJOR: {
          AttributeName: 'PUBL_FRAN_VERSION_MAJOR',
          DisplayLabel: 'Distr.version, major',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        PUBL_FRAN_VERSION_MINOR: {
          AttributeName: 'PUBL_FRAN_VERSION_MINOR',
          DisplayLabel: 'Distr.version, minor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        PUBL_FRAN_VERSION_BUILD: {
          AttributeName: 'PUBL_FRAN_VERSION_BUILD',
          DisplayLabel: 'Build',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10000"',
        },
        PUBL_FRAN_VERSION_RELEASE: {
          AttributeName: 'PUBL_FRAN_VERSION_RELEASE',
          DisplayLabel: 'Distr.version, release',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SUBSYSTEM: {
          AttributeName: 'SUBSYSTEM',
          DisplayLabel: 'Delsystem',
          Hint: 'Grundsystem/Avenycentralen/Anläggningsredovisning/Bisättningsjournal/Bokning/Budget/Diarium/Ekonomi/Grav/Karta/Kremation/Kremationsjournal/Kundreskontra/Lager/Leverantörsreskontra/Musik/Order/Fakturering/Organisation/Person/Program/Underhåll/Stiftelser/Systemadministration/Teknik/Tidredovisning/WebAveny Bokning/WebAveny Bisättningsjournal/WebAveny Ekonomi/WebAveny Grav/WebAveny Leverantörsreskontra/WebAveny Order/WebAveny Tid/Web Grundsystem',
          DataType: 'Enum',
          EnumValues: new Map([['GRUNDSYSTEM', 'Grundsystem'], ['AVENYCENTRALEN', 'Avenycentralen'], ['ANLAGGNINGSREDOVISNING', 'Anläggningsredovisning'], ['BISATTNINGSJOURNAL', 'Bisättningsjournal'], ['BOKNING', 'Bokning'], ['BUDGET', 'Budget'], ['DIARIUM', 'Diarium'], ['EKONOMI', 'Ekonomi'], ['GRAV', 'Grav'], ['KARTA', 'Karta'], ['KREMATION', 'Kremation'], ['KREMATIONSJOURNAL', 'Kremationsjournal'], ['KUNDRESKONTRA', 'Kundreskontra'], ['LAGER', 'Lager'], ['LEVERANTORSRESKONTRA', 'Leverantörsreskontra'], ['MUSIK', 'Musik'], ['ORDER_FAKTURERING', 'Order/Fakturering'], ['ORGANISATION_PERSON', 'Organisation/Person'], ['PROGRAM_UNDERHALL', 'Program/Underhåll'], ['STIFTELSER', 'Stiftelser'], ['SYSTEMADMINISTRATION', 'Systemadministration'], ['TEKNIK', 'Teknik'], ['TIDREDOVISNING', 'Tidredovisning'], ['WEBAVENY_BOKNING', 'WebAveny Bokning'], ['WEBAVENY_BISATTNINGSJOURNAL', 'WebAveny Bisättningsjournal'], ['WEBAVENY_EKONOMI', 'WebAveny Ekonomi'], ['WEBAVENY_GRAV', 'WebAveny Grav'], ['WEBAVENY_LEVERANTORSRESKONTRA', 'WebAveny Leverantörsreskontra'], ['WEBAVENY_ORDER', 'WebAveny Order'], ['WEBAVENY_TID', 'WebAveny Tid'], ['WEB_GRUNDSYSTEM', 'Web Grundsystem']]),
          EnumSortValues: new Map([['GRUNDSYSTEM', 'GND'], ['AVENYCENTRALEN', 'ACC'], ['ANLAGGNINGSREDOVISNING', 'AR'], ['BISATTNINGSJOURNAL', 'BJ'], ['BOKNING', 'BO'], ['BUDGET', 'BU'], ['DIARIUM', 'DI'], ['EKONOMI', 'EK'], ['GRAV', 'GA'], ['KARTA', 'KA'], ['KREMATION', 'KJ'], ['KREMATIONSJOURNAL', 'KJ'], ['KUNDRESKONTRA', 'KR'], ['LAGER', 'LA'], ['LEVERANTORSRESKONTRA', 'LR'], ['MUSIK', 'MU'], ['ORDER_FAKTURERING', 'OF'], ['ORGANISATION_PERSON', 'OP'], ['PROGRAM_UNDERHALL', 'PU'], ['STIFTELSER', 'ST'], ['SYSTEMADMINISTRATION', 'SYS'], ['TEKNIK', 'TE'], ['TIDREDOVISNING', 'TI'], ['WEBAVENY_BOKNING', 'WBO'], ['WEBAVENY_BISATTNINGSJOURNAL', 'WBJ'], ['WEBAVENY_EKONOMI', 'WEK'], ['WEBAVENY_GRAV', 'WGA'], ['WEBAVENY_LEVERANTORSRESKONTRA', 'WLR'], ['WEBAVENY_ORDER', 'WOF'], ['WEBAVENY_TID', 'WTI'], ['WEB_GRUNDSYSTEM', 'WGR']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GRUNDSYSTEM=Grundsystem;AVENYCENTRALEN=Avenycentralen;ANLAGGNINGSREDOVISNING=Anläggningsredovisning;BISATTNINGSJOURNAL=Bisättningsjournal;BOKNING=Bokning;BUDGET=Budget;DIARIUM=Diarium;EKONOMI=Ekonomi;GRAV=Grav;KARTA=Karta;KREMATION=Kremation;KREMATIONSJOURNAL=Kremationsjournal;KUNDRESKONTRA=Kundreskontra;LAGER=Lager;LEVERANTORSRESKONTRA=Leverantörsreskontra;MUSIK=Musik;ORDER_FAKTURERING=Order/Fakturering;ORGANISATION_PERSON=Organisation/Person;PROGRAM_UNDERHALL=Program/Underhåll;STIFTELSER=Stiftelser;SYSTEMADMINISTRATION=Systemadministration;TEKNIK=Teknik;TIDREDOVISNING=Tidredovisning;WEBAVENY_BOKNING=WebAveny Bokning;WEBAVENY_BISATTNINGSJOURNAL=WebAveny Bisättningsjournal;WEBAVENY_EKONOMI=WebAveny Ekonomi;WEBAVENY_GRAV=WebAveny Grav;WEBAVENY_LEVERANTORSRESKONTRA=WebAveny Leverantörsreskontra;WEBAVENY_ORDER=WebAveny Order;WEBAVENY_TID=WebAveny Tid;WEB_GRUNDSYSTEM=Web Grundsystem"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        RUTIN_ID: {
          AttributeName: 'RUTIN_ID',
          DisplayLabel: 'Förekommer i rutin',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HJALP_UPPDATERAD: {
          AttributeName: 'HJALP_UPPDATERAD',
          DisplayLabel: 'Hjälp uppdaterad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        SENAST_ANDRAD: {
          AttributeName: 'SENAST_ANDRAD',
          DisplayLabel: 'Senast ändrad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.notless,
        },
        SENAST_ANDRAD_SIGN: {
          AttributeName: 'SENAST_ANDRAD_SIGN',
          DisplayLabel: 'Ändrad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        UPPG_NR: {
          AttributeName: 'UPPG_NR',
          DisplayLabel: 'Uppgiftsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="1000000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        UPPFOLJN_KOD: {
          AttributeName: 'UPPFOLJN_KOD',
          DisplayLabel: 'Uppföljningskod',
          Hint: 'Huvudprojekt/Delprojekt/Versionsprojekt/Odefinierat',
          DataType: 'Enum',
          EnumValues: new Map([['HUVUDPROJEKT', 'Huvudprojekt'], ['DELPROJEKT', 'Delprojekt'], ['VERSIONSPROJEKT', 'Versionsprojekt'], ['ODEFINIERAT', 'Odefinierat']]),
          EnumSortValues: new Map([['HUVUDPROJEKT', '1'], ['DELPROJEKT', '2'], ['VERSIONSPROJEKT', '3'], ['ODEFINIERAT', '9']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="HUVUDPROJEKT=Huvudprojekt;DELPROJEKT=Delprojekt;VERSIONSPROJEKT=Versionsprojekt;ODEFINIERAT=Odefinierat"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        SPEC_ANSVARIG: {
          AttributeName: 'SPEC_ANSVARIG',
          DisplayLabel: 'Speciferas av',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Publ_fran_Version: {
          AttributeName: 'Publ_fran_Version',
          DisplayLabel: 'Publicerad från version',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Ansvarig_Sign: {
          AttributeName: 'Ansvarig_Sign',
          DisplayLabel: 'Ansvarig prog',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        RutinNamn: {
          AttributeName: 'RutinNamn',
          DisplayLabel: 'Rutinnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        SenastAndrad: {
          AttributeName: 'SenastAndrad',
          DisplayLabel: 'Senast ändrad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RegistreratAv_Sign: {
          AttributeName: 'RegistreratAv_Sign',
          DisplayLabel: 'Registrerat av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        SpecasAv: {
          AttributeName: 'SpecasAv',
          DisplayLabel: 'Ansvarig spec',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        HJALP_SKA_SKRIVAS: {
          AttributeName: 'HJALP_SKA_SKRIVAS',
          DisplayLabel: 'Hjälp ska skrivas',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        SENAST_GRANSKAD: {
          AttributeName: 'SENAST_GRANSKAD',
          DisplayLabel: 'Senast kontrollerad, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notgreater,
        },
        SENAST_GRANSKAD_SIGN: {
          AttributeName: 'SENAST_GRANSKAD_SIGN',
          DisplayLabel: 'Senast kontrollerad, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SENAST_GRANSKAD_NOTERING: {
          AttributeName: 'SENAST_GRANSKAD_NOTERING',
          DisplayLabel: 'Senast kontrollerad, notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        HUVUDUPPG_NR: {
          AttributeName: 'HUVUDUPPG_NR',
          DisplayLabel: 'Huvuduppgifts nr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Huvuduppgift_Status: {
          AttributeName: 'Huvuduppgift_Status',
          DisplayLabel: 'Huvuduppgiftstatus/Status',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Huvuduppgift_prioritet: {
          AttributeName: 'Huvuduppgift_prioritet',
          DisplayLabel: 'Huvuduppgiftsprio/prioritet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        Huvuduppgift_Uppgnr: {
          AttributeName: 'Huvuduppgift_Uppgnr',
          DisplayLabel: 'Huvuduppgiftsnr/uppgiftsnr',
          Hint: 'Eventuell huvuduppgifts nr eller eget nr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        Huvuduppg_Titel: {
          AttributeName: 'Huvuduppg_Titel',
          DisplayLabel: 'Huvuduppg,titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        ExtIntBeskr: {
          AttributeName: 'ExtIntBeskr',
          DisplayLabel: 'Extern/Intern beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ExtIntTitel: {
          AttributeName: 'ExtIntTitel',
          DisplayLabel: 'Extern/Intern titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        delsystemRutinTitel: {
          AttributeName: 'delsystemRutinTitel',
          DisplayLabel: 'delsystemRutinTitel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FinnsPaLogg: {
          AttributeName: 'FinnsPaLogg',
          DisplayLabel: 'Finns på ändringslogg',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        TextSok: {
          AttributeName: 'TextSok',
          DisplayLabel: 'Text sökning',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.contains, T.notcontains],
          DefaultCondOperator: T.contains,
        },
        AnsvSpec: {
          AttributeName: 'AnsvSpec',
          DisplayLabel: 'Ansvarig/Specas/Dokumnteras av',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        Huvuduppgift_Tidkvar: {
          AttributeName: 'Huvuduppgift_Tidkvar',
          DisplayLabel: 'Huvuduppgift, tid kvar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="v=40;d=8;h=1";DefaultGroup="h";GroupTexts="v=v;vecka=v;veckor=v;d=d;dag=d;dagar=d;t=t;tim=t;timmar=t"',
          FormatterDisplayParams: 'Groups="v=40;d=8;h=1"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        Huvuduppgift_Antal: {
          AttributeName: 'Huvuduppgift_Antal',
          DisplayLabel: 'Huvuduppgift, antal uppg',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        Verksamhetsansvar: {
          AttributeName: 'Verksamhetsansvar',
          DisplayLabel: 'Verksamhetsansvar',
          Hint: 'Administration/Ekonomi/Tid/Församling/Kyrkogård/Grundsystem/Övrigt',
          DataType: 'Enum',
          EnumValues: new Map([['ADMINISTRATION', 'Administration'], ['EKONOMI_TID', 'Ekonomi/Tid'], ['FORSAMLING_KYRKOGARD', 'Församling/Kyrkogård'], ['GRUNDSYSTEM', 'Grundsystem'], ['OVRIGT', 'Övrigt']]),
          EnumSortValues: new Map([['ADMINISTRATION', 'ADM'], ['EKONOMI_TID', 'EK'], ['FORSAMLING_KYRKOGARD', 'FK'], ['GRUNDSYSTEM', 'GND'], ['OVRIGT', 'OVR']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ADMINISTRATION=Administration;EKONOMI_TID=Ekonomi/Tid;FORSAMLING_KYRKOGARD=Församling/Kyrkogård;GRUNDSYSTEM=Grundsystem;OVRIGT=Övrigt"',
          InterfaceType: 'ifChecklist',
        },
        DOK_ANSVARIG: {
          AttributeName: 'DOK_ANSVARIG',
          DisplayLabel: 'Dokumenteras av',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Dokansvarig_Sign: {
          AttributeName: 'Dokansvarig_Sign',
          DisplayLabel: 'Dokumenteras av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UppgiftenHos: {
          AttributeName: 'UppgiftenHos',
          DisplayLabel: 'Uppgiften hos',
          Hint: 'Signatur för den som ansvarar (programmerar, dokumenterar, specar) nu',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        UtdeladArbetsuppgiftId: {
          AttributeName: 'UtdeladArbetsuppgiftId',
          DisplayLabel: 'Utdelad arbetsuppgift, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'AVENYANVANDARE_ID': {type: 'String', defaultValue: ''}},
        },
        Delprogram: {
          AttributeName: 'Delprogram',
          DisplayLabel: 'Delprogram',
          Hint: 'Anläggning/Bisättningsjournal/Bokning/Budget/Diarium/Ekonomi/Grav/Grundsystem/Karta/Kremationsjournal/Leverantörsreskontra/Order/Fakt/Musik/Stiftelser/Teknik/Tid och personal/Övrigt',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNING', 'Anläggning'], ['BISATTNINGSJOURNAL', 'Bisättningsjournal'], ['BOKNING', 'Bokning'], ['BUDGET', 'Budget'], ['DIARIUM', 'Diarium'], ['EKONOMI', 'Ekonomi'], ['GRAV', 'Grav'], ['GRUNDSYSTEM', 'Grundsystem'], ['KARTA', 'Karta'], ['KREMATIONSJOURNAL', 'Kremationsjournal'], ['LEVERANTORSRESKONTRA', 'Leverantörsreskontra'], ['ORDER_FAKT', 'Order/Fakt'], ['MUSIK', 'Musik'], ['STIFTELSER', 'Stiftelser'], ['TEKNIK', 'Teknik'], ['TID_OCH_PERSONAL', 'Tid och personal'], ['OVRIGT', 'Övrigt']]),
          EnumSortValues: new Map([['ANLAGGNING', 'AR'], ['BISATTNINGSJOURNAL', 'BJ'], ['BOKNING', 'BO'], ['BUDGET', 'BU'], ['DIARIUM', 'DI'], ['EKONOMI', 'EK'], ['GRAV', 'GA'], ['GRUNDSYSTEM', 'GND'], ['KARTA', 'KA'], ['KREMATIONSJOURNAL', 'KJ'], ['LEVERANTORSRESKONTRA', 'LR'], ['ORDER_FAKT', 'OF'], ['MUSIK', 'MU'], ['STIFTELSER', 'ST'], ['TEKNIK', 'TE'], ['TID_OCH_PERSONAL', 'TI'], ['OVRIGT', 'OVR']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNING=Anläggning;BISATTNINGSJOURNAL=Bisättningsjournal;BOKNING=Bokning;BUDGET=Budget;DIARIUM=Diarium;EKONOMI=Ekonomi;GRAV=Grav;GRUNDSYSTEM=Grundsystem;KARTA=Karta;KREMATIONSJOURNAL=Kremationsjournal;LEVERANTORSRESKONTRA=Leverantörsreskontra;ORDER_FAKT=Order/Fakt;MUSIK=Musik;STIFTELSER=Stiftelser;TEKNIK=Teknik;TID_OCH_PERSONAL=Tid och personal;OVRIGT=Övrigt"',
          InterfaceType: 'ifChecklist',
        },
        FORESLAGEN_VERSION: {
          AttributeName: 'FORESLAGEN_VERSION',
          DisplayLabel: 'Föreslagen version',
          Hint: 'Befintlig version/Nästa version/Nästa års version/Ej vald',
          DataType: 'Enum',
          EnumValues: new Map([['BEFINTLIG_VERSION', 'Befintlig version'], ['NASTA_VERSION', 'Nästa version'], ['NASTA_ARS_VERSION', 'Nästa års version'], ['EJ_VALD', 'Ej vald']]),
          EnumSortValues: new Map([['BEFINTLIG_VERSION', 'B'], ['NASTA_VERSION', 'N'], ['NASTA_ARS_VERSION', 'A'], ['EJ_VALD', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BEFINTLIG_VERSION=Befintlig version;NASTA_VERSION=Nästa version;NASTA_ARS_VERSION=Nästa års version;EJ_VALD=Ej vald"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TID_UPPSK_SPEC: {
          AttributeName: 'TID_UPPSK_SPEC',
          DisplayLabel: 'Tid uppskattad, spec/dok',
          Hint: 'Uppskattad tid för spec/dokumentation',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="v=40;d=8;h=1";DefaultGroup="h";GroupTexts="v=v;vecka=v;veckor=v;d=d;dag=d;dagar=d;t=t;tim=t;timmar=t"',
          FormatterDisplayParams: 'Groups="v=40;d=8;h=1"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TID_KVAR_SPEC: {
          AttributeName: 'TID_KVAR_SPEC',
          DisplayLabel: 'Tid kvar, spec/dok',
          Hint: 'Tid kvar för spec/dokumentation',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="v=40;d=8;h=1";DefaultGroup="h";GroupTexts="v=v;vecka=v;veckor=v;d=d;dag=d;dagar=d;t=t;tim=t;timmar=t"',
          FormatterDisplayParams: 'Groups="v=40;d=8;h=1"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TotalTidUppsk: {
          AttributeName: 'TotalTidUppsk',
          DisplayLabel: 'Tid uppskattad, totalt',
          Hint: 'Uppskattad tid prog+spec',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="v=40;d=8;h=1";DefaultGroup="h";GroupTexts="v=v;vecka=v;veckor=v;d=d;dag=d;dagar=d;t=t;tim=t;timmar=t"',
          FormatterDisplayParams: 'Groups="v=40;d=8;h=1"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TotalTidKvar: {
          AttributeName: 'TotalTidKvar',
          DisplayLabel: 'Tid kvar, totalt',
          Hint: 'Kvarstående tid prog+spec',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="v=40;d=8;h=1";DefaultGroup="h";GroupTexts="v=v;vecka=v;veckor=v;d=d;dag=d;dagar=d;t=t;tim=t;timmar=t"',
          FormatterDisplayParams: 'Groups="v=40;d=8;h=1"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        CommitText: {
          AttributeName: 'CommitText',
          DisplayLabel: 'Committ text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RELEASE_ID: {
          AttributeName: 'RELEASE_ID',
          DisplayLabel: 'Klart till release',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SENAST_GODKAND_DATUM: {
          AttributeName: 'SENAST_GODKAND_DATUM',
          DisplayLabel: 'Godkänd senast datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        JIRA_KEY: {
          AttributeName: 'JIRA_KEY',
          DisplayLabel: 'Jira key',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'PUProgramAndringBlob',
          AssociatedComponentName: 'ProgramAndringBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        RegistreratAv: {
          AssociationName: 'RegistreratAv',
          DisplayLabel: 'Registrerat av',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Ansvarig: {
          AssociationName: 'Ansvarig',
          DisplayLabel: 'Ansvarig',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Rutin: {
          AssociationName: 'Rutin',
          DisplayLabel: 'Rutin',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSRutin',
          AssociatedComponentName: 'Rutin',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AnsvSpec: {
          AssociationName: 'AnsvSpec',
          DisplayLabel: 'Ansvarig specning',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Huvuduppgift: {
          AssociationName: 'Huvuduppgift',
          DisplayLabel: 'Huvuduppgift',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'PUProgramAndring',
          AssociatedComponentName: 'ProgramAndring',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AnsvDok: {
          AssociationName: 'AnsvDok',
          DisplayLabel: 'Ansvarig dokumentation',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Release: {
          AssociationName: 'Release',
          DisplayLabel: 'Planerad till release',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'PUUppdatering',
          AssociatedComponentName: 'Uppdatering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'PUProgAndrOLE',
          AssociatedComponentName: 'ProgAndrOLE',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        FinnsFranVersion: {
          AssociationName: 'FinnsFranVersion',
          DisplayLabel: 'Finns från version',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'PUFinnsFranVer',
          AssociatedComponentName: 'FinnsFranVersion',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        StatusLogg: {
          AssociationName: 'StatusLogg',
          DisplayLabel: 'Statuslogg',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'PUStatusLogg',
          AssociatedComponentName: 'StatusLogg',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        ProgAndrPerRutin: {
          AssociationName: 'ProgAndrPerRutin',
          DisplayLabel: 'Program ändring per rutin',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'PUProgramAndring',
          AssociatedComponentName: 'ProgramAndring',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        FinnsPaLogg: {
          AssociationName: 'FinnsPaLogg',
          DisplayLabel: 'Finns på logg',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'PUFinnsPaLogg',
          AssociatedComponentName: 'FinnsPaLogg',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Deluppgift: {
          AssociationName: 'Deluppgift',
          DisplayLabel: 'Deluppgift',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'PUProgramAndringDel',
          AssociatedComponentName: 'ProgramAndringDel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Bilder: {
          AssociationName: 'Bilder',
          DisplayLabel: 'Bilder',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'PUProgramAndringBild',
          AssociatedComponentName: 'ProgramAndringBild',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        IngProgandr: {
          AssociationName: 'IngProgandr',
          DisplayLabel: 'Ingående programändringar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'PUProgramAndring',
          AssociatedComponentName: 'ProgramAndring',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    PUProgramAndringBlob: {
      CollectionName: 'PUProgramAndringBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ProgramAndringBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'PUProgramAndringBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'PUProgramAndringBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'PUProgramAndringBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'PUProgramAndringBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING_INT: {
          AttributeName: 'BESKRIVNING_INT',
          DisplayLabel: 'Intern beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BESKRIVNING_EXT: {
          AttributeName: 'BESKRIVNING_EXT',
          DisplayLabel: 'Extern beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        HJALP_LANKAR: {
          AttributeName: 'HJALP_LANKAR',
          DisplayLabel: 'Länkar till hjälpen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
      },
      Associations: {
      },
    },
    PUDatabasloggRad: {
      CollectionName: 'PUDatabasloggRad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'DatabasloggRad',
        Abstract: false,
        SOLabel: 'Rad för databaslogg',
        SOGLabel: 'Rad för databaslogg',
        SBLabel: 'Raden för databaslogg',
        SBGLabel: 'Raden för databaslogg',
        POLabel: 'Rader för databaslogg',
        POGLabel: 'Rader för databaslogg',
        PBLabel: 'Raderna för databaslogg',
        PBGLabel: 'Raderna för databaslogg',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Raden för databaslogg primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Raden för databaslogg versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Raden för databaslogg id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Raden för databaslogg fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="1000000"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="1000000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        SQL_SATS: {
          AttributeName: 'SQL_SATS',
          DisplayLabel: 'SQL-sats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        IGNORERA_FEL: {
          AttributeName: 'IGNORERA_FEL',
          DisplayLabel: 'Ignorera fel',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        KortSQL: {
          AttributeName: 'KortSQL',
          DisplayLabel: 'SQL-sats (kort)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    PUStatusLogg: {
      CollectionName: 'PUStatusLogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'StatusLogg',
        Abstract: false,
        SOLabel: 'Statuslogg',
        SOGLabel: 'Statuslogg',
        SBLabel: 'Statusloggen',
        SBGLabel: 'Statusloggen',
        POLabel: 'Statusloggar',
        POGLabel: 'Statusloggar',
        PBLabel: 'Statusloggarna',
        PBGLabel: 'Statusloggarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Statusloggen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Statusloggen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Statusloggen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Statusloggen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Felrapporterad/Förslag/Granskad/Beslutad av delprog.ansv/Skall specas/Specning pågår/Utdelad för programmering/Mottagen av programmerare/Påbörjad programmering/Klar för programtest/Skall godkännas/Godkänd, hanteras i aktuell version/Publicerad i aktuell version/Dokumenteras, i övrigt klar/Godkänn dokumentation, i övrigt klar/Klar/Refuserad',
          DataType: 'Enum',
          EnumValues: new Map([['FELRAPPORTERAD', 'Felrapporterad'], ['FORSLAG', 'Förslag'], ['GRANSKAD', 'Granskad'], ['BESLUTAD_AV_DELPROG_ANSV', 'Beslutad av delprog.ansv'], ['SKALL_SPECAS', 'Skall specas'], ['SPECNING_PAGAR', 'Specning pågår'], ['UTDELAD_FOR_PROGRAMMERING', 'Utdelad för programmering'], ['MOTTAGEN_AV_PROGRAMMERARE', 'Mottagen av programmerare'], ['PABORJAD_PROGRAMMERING', 'Påbörjad programmering'], ['KLAR_FOR_PROGRAMTEST', 'Klar för programtest'], ['SKALL_GODKANNAS', 'Skall godkännas'], ['GODKAND__HANTERAS_I_AKTUELL_VERSION', 'Godkänd, hanteras i aktuell version'], ['PUBLICERAD_I_AKTUELL_VERSION', 'Publicerad i aktuell version'], ['DOKUMENTERAS__I_OVRIGT_KLAR', 'Dokumenteras, i övrigt klar'], ['GODKANN_DOKUMENTATION__I_OVRIGT_KLAR', 'Godkänn dokumentation, i övrigt klar'], ['KLAR', 'Klar'], ['REFUSERAD', 'Refuserad']]),
          EnumSortValues: new Map([['FELRAPPORTERAD', '4'], ['FORSLAG', 'F'], ['GRANSKAD', 'E'], ['BESLUTAD_AV_DELPROG_ANSV', '5'], ['SKALL_SPECAS', 'S'], ['SPECNING_PAGAR', 'P'], ['UTDELAD_FOR_PROGRAMMERING', 'C'], ['MOTTAGEN_AV_PROGRAMMERARE', 'D'], ['PABORJAD_PROGRAMMERING', 'B'], ['KLAR_FOR_PROGRAMTEST', 'A'], ['SKALL_GODKANNAS', '6'], ['GODKAND__HANTERAS_I_AKTUELL_VERSION', 'H'], ['PUBLICERAD_I_AKTUELL_VERSION', 'V'], ['DOKUMENTERAS__I_OVRIGT_KLAR', '7'], ['GODKANN_DOKUMENTATION__I_OVRIGT_KLAR', '8'], ['KLAR', 'K'], ['REFUSERAD', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FELRAPPORTERAD=Felrapporterad;FORSLAG=Förslag;GRANSKAD=Granskad;BESLUTAD_AV_DELPROG_ANSV=Beslutad av delprog.ansv;SKALL_SPECAS=Skall specas;SPECNING_PAGAR=Specning pågår;UTDELAD_FOR_PROGRAMMERING=Utdelad för programmering;MOTTAGEN_AV_PROGRAMMERARE=Mottagen av programmerare;PABORJAD_PROGRAMMERING=Påbörjad programmering;KLAR_FOR_PROGRAMTEST=Klar för programtest;SKALL_GODKANNAS=Skall godkännas;GODKAND__HANTERAS_I_AKTUELL_VERSION=Godkänd, hanteras i aktuell version;PUBLICERAD_I_AKTUELL_VERSION=Publicerad i aktuell version;DOKUMENTERAS__I_OVRIGT_KLAR=Dokumenteras, i övrigt klar;GODKANN_DOKUMENTATION__I_OVRIGT_KLAR=Godkänn dokumentation, i övrigt klar;KLAR=Klar;REFUSERAD=Refuserad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        ANDRAT_AV: {
          AttributeName: 'ANDRAT_AV',
          DisplayLabel: 'Ändrat av',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum för ändring',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Tid för ändring',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Anvandare: {
          AttributeName: 'Anvandare',
          DisplayLabel: 'Användare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    PUUppdateringAnsvar: {
      CollectionName: 'PUUppdateringAnsvar',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'UppdateringAnsvar',
        Abstract: false,
        SOLabel: 'UppdateringAnsvar',
        SOGLabel: 'UppdateringAnsvar',
        SBLabel: 'UppdateringAnsvar',
        SBGLabel: 'UppdateringAnsvar',
        POLabel: 'UppdateringAnsvar',
        POGLabel: 'UppdateringAnsvar',
        PBLabel: 'UppdateringAnsvar',
        PBGLabel: 'UppdateringAnsvar',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'UppdateringAnsvar primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'UppdateringAnsvar versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'UppdateringAnsvar id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STEG_ID: {
          AttributeName: 'STEG_ID',
          DisplayLabel: 'STEG_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'USER_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Ej klar/Ej relevant/Klar',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_KLAR', 'Ej klar'], ['EJ_RELEVANT', 'Ej relevant'], ['KLAR', 'Klar']]),
          EnumSortValues: new Map([['EJ_KLAR', 'E'], ['EJ_RELEVANT', 'R'], ['KLAR', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_KLAR=Ej klar;EJ_RELEVANT=Ej relevant;KLAR=Klar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS_USER_ID: {
          AttributeName: 'STATUS_USER_ID',
          DisplayLabel: 'STATUS_USER_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        STATUS_TID: {
          AttributeName: 'STATUS_TID',
          DisplayLabel: 'Status tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DELPROGRAM: {
          AttributeName: 'DELPROGRAM',
          DisplayLabel: 'Delprogram',
          Hint: 'Anläggning/Bisättningsjournal/Bokning/Budget/Diarium/Ekonomi/Grav/Grundsystem/Kremationsjournal/Leverantörsreskontra/Order/Fakt/Musik/Stiftelser/Teknik/Tid och personal/Övrigt',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNING', 'Anläggning'], ['BISATTNINGSJOURNAL', 'Bisättningsjournal'], ['BOKNING', 'Bokning'], ['BUDGET', 'Budget'], ['DIARIUM', 'Diarium'], ['EKONOMI', 'Ekonomi'], ['GRAV', 'Grav'], ['GRUNDSYSTEM', 'Grundsystem'], ['KREMATIONSJOURNAL', 'Kremationsjournal'], ['LEVERANTORSRESKONTRA', 'Leverantörsreskontra'], ['ORDER_FAKT', 'Order/Fakt'], ['MUSIK', 'Musik'], ['STIFTELSER', 'Stiftelser'], ['TEKNIK', 'Teknik'], ['TID_OCH_PERSONAL', 'Tid och personal'], ['OVRIGT', 'Övrigt']]),
          EnumSortValues: new Map([['ANLAGGNING', 'AR'], ['BISATTNINGSJOURNAL', 'BJ'], ['BOKNING', 'BO'], ['BUDGET', 'BU'], ['DIARIUM', 'DI'], ['EKONOMI', 'EK'], ['GRAV', 'GA'], ['GRUNDSYSTEM', 'GND'], ['KREMATIONSJOURNAL', 'KJ'], ['LEVERANTORSRESKONTRA', 'LR'], ['ORDER_FAKT', 'OF'], ['MUSIK', 'MU'], ['STIFTELSER', 'ST'], ['TEKNIK', 'TE'], ['TID_OCH_PERSONAL', 'TI'], ['OVRIGT', 'OVR']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNING=Anläggning;BISATTNINGSJOURNAL=Bisättningsjournal;BOKNING=Bokning;BUDGET=Budget;DIARIUM=Diarium;EKONOMI=Ekonomi;GRAV=Grav;GRUNDSYSTEM=Grundsystem;KREMATIONSJOURNAL=Kremationsjournal;LEVERANTORSRESKONTRA=Leverantörsreskontra;ORDER_FAKT=Order/Fakt;MUSIK=Musik;STIFTELSER=Stiftelser;TEKNIK=Teknik;TID_OCH_PERSONAL=Tid och personal;OVRIGT=Övrigt"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Verksamhetsansvar: {
          AttributeName: 'Verksamhetsansvar',
          DisplayLabel: 'Verksamhetsansvar',
          Hint: 'Ekonomi/Tid/Församling/Kyrkogård/Grundsystem/Teknik/Övrigt',
          DataType: 'Enum',
          EnumValues: new Map([['EKONOMI_TID', 'Ekonomi/Tid'], ['FORSAMLING_KYRKOGARD', 'Församling/Kyrkogård'], ['GRUNDSYSTEM', 'Grundsystem'], ['TEKNIK', 'Teknik'], ['OVRIGT', 'Övrigt']]),
          EnumSortValues: new Map([['EKONOMI_TID', 'EK'], ['FORSAMLING_KYRKOGARD', 'FK'], ['GRUNDSYSTEM', 'GND'], ['TEKNIK', 'TE'], ['OVRIGT', 'OVR']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EKONOMI_TID=Ekonomi/Tid;FORSAMLING_KYRKOGARD=Församling/Kyrkogård;GRUNDSYSTEM=Grundsystem;TEKNIK=Teknik;OVRIGT=Övrigt"',
          InterfaceType: 'ifChecklist',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDNINGSNR: {
          AttributeName: 'ORDNINGSNR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        ROLL: {
          AttributeName: 'ROLL',
          DisplayLabel: 'Roll',
          Hint: 'Delprogramansvarig/Försäljningsansvarig/Programmeringsansvarig/Totalansvarig/Verksamhetschef',
          DataType: 'Enum',
          EnumValues: new Map([['DELPROGRAMANSVARIG', 'Delprogramansvarig'], ['FORSALJNINGSANSVARIG', 'Försäljningsansvarig'], ['PROGRAMMERINGSANSVARIG', 'Programmeringsansvarig'], ['TOTALANSVARIG', 'Totalansvarig'], ['VERKSAMHETSCHEF', 'Verksamhetschef']]),
          EnumSortValues: new Map([['DELPROGRAMANSVARIG', 'DPA'], ['FORSALJNINGSANSVARIG', 'FA'], ['PROGRAMMERINGSANSVARIG', 'PA'], ['TOTALANSVARIG', 'TA'], ['VERKSAMHETSCHEF', 'VC']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="DELPROGRAMANSVARIG=Delprogramansvarig;FORSALJNINGSANSVARIG=Försäljningsansvarig;PROGRAMMERINGSANSVARIG=Programmeringsansvarig;TOTALANSVARIG=Totalansvarig;VERKSAMHETSCHEF=Verksamhetschef"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        anvandare: {
          AssociationName: 'anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        uppdateringssteg: {
          AssociationName: 'uppdateringssteg',
          DisplayLabel: 'Uppdateringssteg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'PUUppdateringssteg',
          AssociatedComponentName: 'Uppdateringssteg',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        StatusAnvandare: {
          AssociationName: 'StatusAnvandare',
          DisplayLabel: 'Status, användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    PUWebAnswer: {
      CollectionName: 'PUWebAnswer',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'WebAnswer',
        Abstract: false,
        SOLabel: 'Web svar',
        SOGLabel: 'Web svar',
        SBLabel: 'Web svaret',
        SBGLabel: 'Web svaret',
        POLabel: 'Web svaren',
        POGLabel: 'Web svaren',
        PBLabel: 'Web svaren',
        PBGLabel: 'Web svaren',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Web svaret primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Web svaret versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Web svaret id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Web svaret fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUB_QUESTION_NO: {
          AttributeName: 'SUB_QUESTION_NO',
          DisplayLabel: 'Delsvar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SESSION_ID: {
          AttributeName: 'SESSION_ID',
          DisplayLabel: 'Sessions id',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANSWER: {
          AttributeName: 'ANSWER',
          DisplayLabel: 'Svar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        COMMENT: {
          AttributeName: 'COMMENT',
          DisplayLabel: 'Kommentar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    PUWebSurvey: {
      CollectionName: 'PUWebSurvey',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'WebSurvey',
        Abstract: false,
        SOLabel: 'Webenkät',
        SOGLabel: 'Webenkät',
        SBLabel: 'Webenkäten',
        SBGLabel: 'Webenkäten',
        POLabel: 'Webenkäter',
        POGLabel: 'Webenkäter',
        PBLabel: 'Webenkäterna',
        PBGLabel: 'Webenkäterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Webenkäten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Webenkäten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Webenkäten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Webenkäten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DESCRIPTION: {
          AttributeName: 'DESCRIPTION',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STYLESHEET: {
          AttributeName: 'STYLESHEET',
          DisplayLabel: 'Stilmall',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Skapad/Aktiv/Avslutad',
          DataType: 'Enum',
          EnumValues: new Map([['SKAPAD', 'Skapad'], ['AKTIV', 'Aktiv'], ['AVSLUTAD', 'Avslutad']]),
          EnumSortValues: new Map([['SKAPAD', 'A'], ['AKTIV', 'K'], ['AVSLUTAD', 'S']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKAPAD=Skapad;AKTIV=Aktiv;AVSLUTAD=Avslutad"',
        },
        REQUIRED_MARK: {
          AttributeName: 'REQUIRED_MARK',
          DisplayLabel: 'Svar krävs markering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NOT_COMPLETED_TEXT: {
          AttributeName: 'NOT_COMPLETED_TEXT',
          DisplayLabel: 'Enkät inte komplett',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Fragor: {
          AssociationName: 'Fragor',
          DisplayLabel: 'Frågor',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'PUWebQuestion',
          AssociatedComponentName: 'WebQuestion',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    PUWebQuestion: {
      CollectionName: 'PUWebQuestion',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'WebQuestion',
        Abstract: false,
        SOLabel: 'Webfråga',
        SOGLabel: 'Webfråga',
        SBLabel: 'Webfrågan',
        SBGLabel: 'Webfrågan',
        POLabel: 'Webfrågor',
        POGLabel: 'Webfrågor',
        PBLabel: 'Webfrågorna',
        PBGLabel: 'Webfrågorna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Webfrågan primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Webfrågan versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Webfrågan id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Webfrågan fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SURVEY_ID: {
          AttributeName: 'SURVEY_ID',
          DisplayLabel: 'Enkät id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        QUESTION_NO: {
          AttributeName: 'QUESTION_NO',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        QUESTION: {
          AttributeName: 'QUESTION',
          DisplayLabel: 'Fråga',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DESCRIPTION: {
          AttributeName: 'DESCRIPTION',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYPE: {
          AttributeName: 'TYPE',
          DisplayLabel: 'Typ',
          Hint: 'Combobox/Radiogrupp/Checklista/Matris/Matris flerval/Text enkelradig/Text flerradig',
          DataType: 'Enum',
          EnumValues: new Map([['COMBOBOX', 'Combobox'], ['RADIOGRUPP', 'Radiogrupp'], ['CHECKLISTA', 'Checklista'], ['MATRIS', 'Matris'], ['MATRIS_FLERVAL', 'Matris flerval'], ['TEXT_ENKELRADIG', 'Text enkelradig'], ['TEXT_FLERRADIG', 'Text flerradig']]),
          EnumSortValues: new Map([['COMBOBOX', 'B'], ['RADIOGRUPP', 'G'], ['CHECKLISTA', 'L'], ['MATRIS', 'M'], ['MATRIS_FLERVAL', 'N'], ['TEXT_ENKELRADIG', 'S'], ['TEXT_FLERRADIG', 'T']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="COMBOBOX=Combobox;RADIOGRUPP=Radiogrupp;CHECKLISTA=Checklista;MATRIS=Matris;MATRIS_FLERVAL=Matris flerval;TEXT_ENKELRADIG=Text enkelradig;TEXT_FLERRADIG=Text flerradig"',
        },
        REQUIRED: {
          AttributeName: 'REQUIRED',
          DisplayLabel: 'Svar krävs',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        HORIZONTAL: {
          AttributeName: 'HORIZONTAL',
          DisplayLabel: 'Horisontell',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        INCLUDE_COMMENT: {
          AttributeName: 'INCLUDE_COMMENT',
          DisplayLabel: 'Inkludera kommentar',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        COMMENT_TEXT: {
          AttributeName: 'COMMENT_TEXT',
          DisplayLabel: 'Kommentar text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ALTERNATIVES: {
          AttributeName: 'ALTERNATIVES',
          DisplayLabel: 'Alternativ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUBQUESTIONS: {
          AttributeName: 'SUBQUESTIONS',
          DisplayLabel: 'Delfrågor',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Enkat: {
          AssociationName: 'Enkat',
          DisplayLabel: 'Enkät',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'PUWebSurvey',
          AssociatedComponentName: 'WebSurvey',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Svar: {
          AssociationName: 'Svar',
          DisplayLabel: 'Svar',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'PUWebAnswer',
          AssociatedComponentName: 'WebAnswer',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    PUAndringsLogg: {
      CollectionName: 'PUAndringsLogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AndringsLogg',
        Abstract: false,
        SOLabel: 'Ändringslogg',
        SOGLabel: 'Ändringslogg',
        SBLabel: 'Ändringsloggen',
        SBGLabel: 'Ändringsloggen',
        POLabel: 'Ändringsloggar',
        POGLabel: 'Ändringsloggar',
        PBLabel: 'Ändringsloggarna',
        PBGLabel: 'Ändringsloggarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ändringsloggen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ändringsloggen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Ändringsloggen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ändringsloggen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKAPAD_DATUM: {
          AttributeName: 'SKAPAD_DATUM',
          DisplayLabel: 'Skapad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SKAPAD_AV: {
          AttributeName: 'SKAPAD_AV',
          DisplayLabel: 'Skapad av ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifChecklist',
        },
        FROM_DATUM: {
          AttributeName: 'FROM_DATUM',
          DisplayLabel: 'Fr.o.m. datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TOM_DATUM: {
          AttributeName: 'TOM_DATUM',
          DisplayLabel: 'T.o.m. datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FROM_MAJOR: {
          AttributeName: 'FROM_MAJOR',
          DisplayLabel: 'Från och med VersionMajor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FROM_MINOR: {
          AttributeName: 'FROM_MINOR',
          DisplayLabel: 'Från och med VersionMinor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FROM_RELEASE: {
          AttributeName: 'FROM_RELEASE',
          DisplayLabel: 'Från och med VersionRelease',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TOM_MAJOR: {
          AttributeName: 'TOM_MAJOR',
          DisplayLabel: 'Till och med VersionMajor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TOM_MINOR: {
          AttributeName: 'TOM_MINOR',
          DisplayLabel: 'Till och med VersionMinor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TOM_RELEASE: {
          AttributeName: 'TOM_RELEASE',
          DisplayLabel: 'Till och med VersionRelease',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SkapadAv: {
          AttributeName: 'SkapadAv',
          DisplayLabel: 'Skapad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        FromVersion: {
          AttributeName: 'FromVersion',
          DisplayLabel: 'Fr.o.m. version',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TomVersion: {
          AttributeName: 'TomVersion',
          DisplayLabel: 'T.o.m. version',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RELEASE_VERSION_NAME: {
          AttributeName: 'RELEASE_VERSION_NAME',
          DisplayLabel: 'Versionsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RELEASE_DATE: {
          AttributeName: 'RELEASE_DATE',
          DisplayLabel: 'Release datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        FinnsPaLogg: {
          AssociationName: 'FinnsPaLogg',
          DisplayLabel: 'Finns på ändringslogg',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'PUFinnsPaLogg',
          AssociatedComponentName: 'FinnsPaLogg',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
  },
};

export default PU;
